const $ = window.jQuery;

const checkFixedHeader = function () {
    const scrollTop = $(window).scrollTop();
    const $h = $('header.b-h');

    if (!$h.length) {
        return;
    }
    const hTop = $h.offset().top;
    $h[scrollTop > hTop ? 'addClass' : 'removeClass']('b-h_fixed');
};
checkFixedHeader();

$(document).on('scroll', checkFixedHeader);
